import { Report } from './report';
import { comparators } from '../../core/comparators';
import { ActivityReport } from '../../shared/activity-report/activity-report';
import { AdminProtocolAccessReport } from '../../admin/activity-reports/report-types/admin-activity-report-protocol-access';
import { SponsorProtocolAccessReport } from '../../sponsor/activity-reports/report-types/sponsor-protocol-access-report';

export const defaultReportSort: (a: Report | ActivityReport, b: Report | ActivityReport) => number = (a, b) =>
    comparators.dateTimeComparator(b ? b.postedDateTime : null, a ? a.postedDateTime : null);

export const defaultProtocolAccessesSort: (a: AdminProtocolAccessReport | SponsorProtocolAccessReport, b: AdminProtocolAccessReport | SponsorProtocolAccessReport) => number = (a, b) => {
    const dateComparatorResult = comparators.stringComparator(a ? a.siteName : null, b ? b.siteName : null);
    if (dateComparatorResult === 0) {
        return comparators.dateTimeComparator(b ? b.accessGivenDate : null, a ? a.accessGivenDate : null);
    }

    return dateComparatorResult;
};
